module.exports = __webpack_public_path__ + "static/media/classlogs.c2026a73.svg";